import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

type IProps = {
  value: boolean;
  content?: string;
};

export const CheckBoxDisplay: React.FC<IProps> = ({ value, content }) => {
  return (
    <Flex flexDirection={'column'}>
        <Text textStyle={'textBody'}>{content || (value ? 'Checked' : 'Unchecked')}</Text>
    </Flex>
  );
};
